// src/components/auth/ProfileGuard.jsx - Update to store redirect location
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProfileGuard = ({ children, requireProfile = true }) => {
  const { user, userProfile, initialLoading } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (initialLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!user) {
    // Store current location for redirect after login
    if (location.pathname !== '/login' && location.pathname !== '/register') {
      sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    }
    return <Navigate to="/login" replace />;
  }

  // Authenticated but profile not complete - redirect to profile setup
  if (requireProfile && userProfile && !userProfile.profileComplete) {
    return <Navigate to="/profile/setup" replace />;
  }

  // Authenticated and profile complete (or profile not required)
  return children;
};

export default ProfileGuard;